import { PreviewUserDataFragment, UserTagOptionDataFragment } from '../../../../api';

export enum DealerStatus {
    InSession = 'inSession',
    New = 'new',
}

export type SelectedDealer = {
    id: string;
    name: string;
    tagNames: string | null;
    status: DealerStatus;
};

export type InviteQuoteData = {
    dealers: PreviewUserDataFragment[];
    tags: UserTagOptionDataFragment[];
};
